<template>
  <div>
    <vue-up></vue-up>
    <b-navbar
      toggleable="sm"
      type="dark"
      fixed="top"
      class="positionPhone"
      v-if="browserSize.sm === true || browserSize.xs === true"
    >
      <a href="/">
        <img
          width="55"
          height="55"
          class="marginImg"
          src="../assets/olmed.png"
        />
      </a>
      <v-btn href="tel:+48 730 230 674" class="btnColor">+48 730 230 674</v-btn>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav v-for="menu in menuItems" :key="menu.id">
          <b-nav-item :to="menu.path">{{ menu.title }}</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-navbar
      id="nav"
      toggleable="sm"
      type="dark"
      fixed="null"
      class="position"
      :class="toggleNavClass()"
      v-else
    >
      <!-- <a href="/">
        <img
          width="55"
          height="55"
          class="marginImg"
          src="../assets/olmed.png"
        />
      </a> -->
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav v-for="menu in menuItems" :key="menu.id">
          <b-nav-item :to="menu.path">{{ menu.title }}</b-nav-item>
        </b-navbar-nav>
      </b-collapse>

      <!-- <button class="btnColorComp" @click="copy">+48 730 230 674</button> -->
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: "Navbar",

  data: () => ({
    active: false,
    position: 0,
    menuItems: [
      { title: "Start", path: "/", icon: "fas fa-home" },
      { title: "O mnie", path: "/about", icon: "face" },
      { title: "Oferta", path: "/offers", icon: "lock_open" },
      { title: "Metody leczenia", path: "/metods", icon: "lock_open" },
      { title: "Kontakt", path: "/contact", icon: "lock_open" },
    ],
  }),
  computed: {
    browserSize() {
      return this.$vuetify.breakpoint;
    },
  },
  methods: {
    copy() {
      this.$clipboard("+48 730 230 674");
      this.notify();
    },
    notify() {
      // this.$popup({ message: "Skopiowano numer" });
      this.$popup({
        message: "Skopiowano numer",
        delay: 1,
      });
    },
    toggleNavClass() {
      if (this.active == false) {
        return "position";
      } else {
        return "sticky-nav";
      }
    },
  },
  mounted() {
    window.document.onscroll = () => {
      let navBar = document.getElementById("nav");
      if (navBar.offsetTop > 0) {
        this.position = navBar.offsetTop;
      }
      if (this.position > 0 && window.scrollY < this.position) {
        this.active = false;
      } else {
        this.active = true;
      }
    };
  },
};
</script>

<style lang="scss" scoped>
.positionPhone {
  top: 0;
  background: rgba(0, 0, 0, 0.6);
  width: 100%;
  z-index: 1000;
  a:link,
  a:visited {
    color: $backgroundLightness !important;
    text-decoration-line: none;
    font-weight: 800;
  }
  a:hover {
    color: $textColor !important;
    transition: all 0.5s ease-out;
  }
}

.position {
  transition: all 0.1s ease-out;
  top: 0;
  width: 100%;
  z-index: 1000;
  a:link,
  a:visited {
    color: #414149 !important;
    text-decoration-line: none;
    font-weight: 800;
  }
  a:hover {
    color: #453bff !important;
    transition: all 0.5s ease-out;
  }
  ul {
    margin: 0px;
    padding: 0px;
  }
  .nav-link {
    border-right: 1px solid #414149 !important;
    padding: 0em 3.75em !important;
    line-height: 2 !important;
  }
  .navbar-collapse > ul:last-child > li > a {
    border-right: none !important;
  }
}

.sticky-nav {
  transition: all 0.5s ease-out;
  /* transition: 100ms; */
  position: fixed;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
  width: 100%;
  z-index: 1000;
  a:link,
  a:visited {
    color: $backgroundLightness !important;
    text-decoration-line: none;
    font-weight: 800;
  }
  a:hover {
    color: #453bff !important;
    transition: all 0.5s ease-out;
  }
  ul {
    margin: 0px;
    padding: 0px;
  }
  .nav-link {
    border-right: 1px solid $backgroundLightness !important;
    padding: 0em 3.75em !important;
    line-height: 2 !important;
  }
  .navbar-collapse > ul:last-child > li > a {
    border-right: none !important;
  }
}
nav {
  border-bottom: 1px solid #414149 !important;
}

.navbar-collapse {
  justify-content: center !important;
}
.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: $backgroundLightness;
  border-radius: 0.25rem;
}

.btnColor {
  background-color: #453bff !important;
}
.btnColorComp {
  color: $backgroundLightness !important;
  background-color: $primaryProjectColour !important;
  font-weight: 700;
  height: 36px;
  min-width: 64px;
  padding: 0 4px;
  margin: 1px;
  border-radius: 4px;
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 36px;
  min-width: 64px;
  padding: 0 4px;
  margin: 1px;
}
</style>
